import React from "react";
import { PreviewAltCard } from "../../Component";
import { LineChartExample } from "../../charts/Chart";

const LineChartWidget = ({ title, data, period, loading, height = 250 }) => {
  return (
    <PreviewAltCard className="card-bordered h-100">
      <div className="card-title-group mb-3">
        <div className="card-title">
          <h6 className="title">{title}</h6>
          {period && <p className="sub-text text-soft">{period}</p>}
        </div>
      </div>
      <div className="nk-ck-sm" style={{ height: `${height}px`, position: "relative" }}>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Chargement...</span>
            </div>
          </div>
        ) : data && data.labels && data.datasets ? (
          <LineChartExample data={data} legend={true} />
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100 text-muted">
            <p>No data available</p>
          </div>
        )}
      </div>
    </PreviewAltCard>
  );
};

export default LineChartWidget;

